import { AppInstallComponent } from "./website/app-install.component";
import { ExternalRedirectComponent } from "./shared/external-redirect.component";
import { ForgotPasswordComponent } from "./login/forgot-password.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { CookiePolicyComponent } from "./website/cookie-policy.component";
import { DataSecurityComponent } from "./website/data-security.component";
import { CommonModule } from "@angular/common";
import { EmailConfirmationComponent } from "./landing-page/email-confirmation/email-confirmation.component";
import { CloseQbOauthComponent } from "./close-qb-oauth/close-qb-oauth.component";
import { W9UploadComponent } from "./w9-upload/w9-upload.component";
import { CreateComponent } from "./registration/create/create.component";
import { InternalAccCreationGuard } from "./guards/internal-acc-creation.guard";
import { TrialDrawerComponent } from "./landing-page/trial-drawer/trial-drawer.component";

const routes: Routes = [
  { path: "trial", component: ExternalRedirectComponent, data: { url: "https://clienthub.app" } },
  {
    path: "sales/trial",
    component: TrialDrawerComponent,
    pathMatch: "full",
  },
  {
    path: "acc-creation-internal",
    component: CreateComponent,
    canActivate: [InternalAccCreationGuard],
  },
  { path: "email-confirmation/:key", component: EmailConfirmationComponent },
  {
    path: "close-qb-oauth",
    component: CloseQbOauthComponent,
    pathMatch: "full",
  },
  {
    path: "w9-upload/:token",
    component: W9UploadComponent,
  },
  {
    path: "login",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "login/:token",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginModule),
  },
  { path: "forgot-password", component: ForgotPasswordComponent },
  { path: "forgot-password/:uuid", component: ForgotPasswordComponent },

  { 
    path: "terms-of-service", 
    component: ExternalRedirectComponent,
    data: { url: "https://www.clienthub.app/terms-of-service" }
  },
  {
    path: "terms-and-conditions",
    component: ExternalRedirectComponent,
    data: { url: "https://www.clienthub.app/terms-of-service" }
  },

  { 
    path: "privacy-policy", 
    component: ExternalRedirectComponent,
    data: { url: "https://www.clienthub.app/privacy-policy" }
  },
  { 
    path: "privacy-notice", 
    component: ExternalRedirectComponent,
    data: { url: "https://www.clienthub.app/privacy-policy" }
  },

  { path: "cookie-policy", component: CookiePolicyComponent },
  { path: "data-security", component: DataSecurityComponent },

  { path: "install", component: AppInstallComponent },

  {
    path: "",
    redirectTo: "/login",
    pathMatch: "full",
  },
  {
    path: "",
    loadChildren: () =>
      import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    CommonModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
